//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Die.js";
import "../Features/Features.FeatureBuilder.js";
import "../Die/Die.DieAttributesBuilder.js";
import "../no/Section.js";
import "../Die/Die.DiePlaneBuilder.js";
import "../no/Expression.js";
import "../Die/Die.DieDirectionBuilder.js";
import "../Die/Die.DieBooleanBuilderList.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/ObjectList.js";
let d=[[[0,"AngleTolerance",1,0],[1,"BaseAttributes",0,"Die.DieAttributesBuilder",0],[1,"BaseFlangeSection",0,"Section",0],[1,"BaseOrientation",0,"Die.DiePlaneBuilder",0],[1,"CenterlineSlotAttributes",0,"Die.DieAttributesBuilder",0],[0,"CenterlineSlotCreate",1,0],[1,"CenterlineSlotDepth",0,"Expression",0],[1,"CenterlineSlotDirection",0,"Die.DieDirectionBuilder",0],[1,"CenterlineSlotWidth",0,"Expression",0],[1,"DeckCutoutsSection",0,"Section",0],[1,"DeckThickness",0,"Expression",0],[1,"DieBooleansList",0,"Die.DieBooleanBuilderList",0],[0,"DistanceTolerance",1,0],[1,"FlangeThickness",0,"Expression",0],[1,"MainDeckAttributes",0,"Die.DieAttributesBuilder",0],[1,"MainDeckOffset",0,"Expression",0],[1,"MainDeckPlane",0,"Die.DiePlaneBuilder",0],[1,"MainDeckSection",0,"Section",0],[1,"WallThickness",0,"Expression",0]],[],[]];
SPLM.Die.DieShoeBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Die.DieShoeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;